import moment from "moment";
import { checkLocalStore } from "@/services/firebase/getLocalStore";
import msDataProvider from "@/services/msDataProvider";


export async function addAction(action: string, error: any = "", options: any = {notLogged: false}, userName: string = "", url: string = "") {
  let binding: any = {}
  binding = await checkLocalStore()

  try {
    const params = {
      login_name: binding && binding.loginName || "",
      display_name: binding && binding.displayName || "",
      email: binding && binding.email || "",
      phone_number: binding && binding.phoneNumber || "",
      agent_version: binding && binding.agentVersion || "",
      device_id: binding && binding.deviceId || "",
      device_name: binding && binding.deviceName || "",
      os: binding && binding.os || "",
      server_name: binding && binding.serverName || "",
      created_time: moment().format('DD/MM/YYYY HH:mm:ss'),
      pre_action: "",
      pre_action_time: "",
      error_info: error,
      open_url: url,
      'action': action,
    }
    msDataProvider.executeCommand('userInteractionCreate', params)
  } catch (e) {
    console.log(e)
  }
}

// export async function addIssue(issues: string, options: any = {}) {
//   let binding: any = await checkLocalStore()
//   try {
//     const citiesRef = collection(db, "issues");
//     if (!(binding && binding.userId)) {
//       binding = await checkLocalStore()
//       if (!binding && binding.userId) {
//         return
//       }
//     }
//     const params = {
//       display_name: binding && binding.displayName || "",
//       email: binding && binding.email || "",
//       phone_number: binding && binding.phoneNumber || "",
//       agent_version: binding && binding.agentVersion || "",
//       device_id: binding && binding.deviceId || "",
//       device_name: binding && binding.deviceName || "",
//       created_time: moment().format('DD/MM/YYYY hh:mm:ss'),
//       time_handling: "",
//       'issues': issues,
//     }
//     let data: any = await getLocalFirebase(binding.userId, 'issues')
//     if (data && data.listIssues && Array.isArray(data.listIssues) && data.listIssues.length) {
//       data = [...data.listIssues, ...[params]]
//       await updateDoc(doc(citiesRef, binding.userId), {
//         listIssues: data
//       })
//
//     } else {
//       await setDoc(doc(citiesRef, binding.userId), {
//         listIssues: [params]
//       })
//     }
//   } catch (e) {
//     console.log(e)
//     if (e === "FirebaseError: Failed to get document because the client is offline.") {
//       console.log("offline")
//     }
//   }
// }

